/**
 * How a coding agent should dismiss a cubic finding it won't fix. Every prompt cubic hands to
 * agents uses this sentence, so they all give the same instruction.
 */
export const DISMISS_FINDING_INSTRUCTION =
  "When an issue isn't valid or won't be fixed in this PR, reply in its thread with the reason and then resolve the thread.";
